"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFallbackOptions = (fallback = {}) => {
    return Object.assign({ pollFrequency: 3000, path: "/", secure: false, httpOnly: false }, fallback);
};
//# sourceMappingURL=createFallbackOptions.js.map